import React, { useEffect } from 'react';
// 注册组件
import Comment from '@/component/module_comment';
import TaSemi from '@/component/module_ta-semi';
import ProductImage from '@/component/module_productImage';
import Title from '@/component/module_title';
import Attribute from '@/component/module_attribute';
import LocalStock from '@/component/module_localstock';
import Price from '@/component/module_price';
import Benefits from '@/component/module_benefit';
import MyLazyComponent from '@/common/lazy-load';
import TaPlus from '@/component/module_ta-plus';
import Sku from '@/component/module_sku';
import Sample from '@/component/module_sample';
import Shipping from '@/component/module_shipping';
import Lead from '@/component/module_lead';
import Atmosphere from '@/component/module_atmosphere';
import GuaranteedAtmosphere from '@/component/module_guaranteed_atmosphere';
import Customization from '@/component/module_customization';
import Company from '@/component/module_company';
import SellingPoint from '@/component/module_sellingpoint';
import Recommend from '@/component/module_recommend';
import Actions from '@/component/module_actions';
import loadScript from '@/utils/loadScript';
import BNPLPayment from '@/component/module_bnplPayment';
import FreeShipping from '@/component/module_free_shipping';
import Layout from '@/module/layout';
import Description from '@/component/module_description';
import PageStore from '@/stores/page';
/*
 * 首屏同构渲染组件
 * 非阻塞直出移至Lazy component
 */
const Components = {
  Comment,
  TaSemi,
  ProductImage,
  Title,
  Attribute,
  LocalStock,
  Price,
  Benefits,
  TaPlus,
  Sku,
  Sample,
  Shipping,
  Lead,
  Atmosphere,
  GuaranteedAtmosphere,
  Company,
  SellingPoint,
  Recommend,
  Actions,
  FreeShipping,
  Customization,
  Description,
  BNPLPayment,
} as unknown as {
  [key: string]: () => React.JSX.Element;
};

// 合并同、异步组件
const Structure = (props: DetailTypes.Root) => {
  const pageStore = PageStore((state) => state);

  const loadScripts = async () => {
    // 首屏组件
    await Promise.all([
      loadScript('//s.alicdn.com/@g/sc/sc-details-config/0.1.2/fusion.css', true),
      loadScript('//s.alicdn.com/@g/sc/sc-details-config/0.1.2/fusion.js'),
      loadScript('//s.alicdn.com/@g/mtb/lib-mtop/2.6.1/mtop.js'),
    ]);
    // 激活lazy load
    pageStore.setLoaded();
    // 详情装修+异步组件（sc-details）
    await Promise.all([
      loadScript(
        `//s.alicdn.com/@g/sc/sc-details/${window.detailData.scVersion}/fantasy-index.async.css`,
        true,
      ),
      loadScript(
        `//s.alicdn.com/@g/sc/sc-details/${window.detailData.scVersion}/fantasy-index.async.js`,
      ),
    ]);
    // 异步组件
    await Promise.all([
      loadScript('//s.alicdn.com/@g/sc/sc-details-config/0.1.2/fusion-other.css', true),
      loadScript('//s.alicdn.com/@g/sc/sc-details-config/0.1.2/fusion-other.js'),
    ]);
  };

  // 渲染与执行分离，动态引入静态资源减少阻塞
  useEffect(() => {
    loadScripts().then(() => {
      // 底层固定
      const positionElement = document.querySelector('.layout-bottom');
      if (positionElement) {
        const positionObserver = new IntersectionObserver(([entry]) => {
          try {
            document
              .querySelector('.layout-body')
              ?.classList.toggle('position', entry.isIntersecting);
          } catch (error) {
            console.warn(`position error! ${error}`);
          }
        });
        positionObserver.observe(positionElement);
      }
    });
  }, []);

  // 剔除依赖Fusion及非首屏渲染组件
  if (pageStore.isLoaded) {
    Object.assign(Components, {
      Coupon: MyLazyComponent(
        /* webpackChunkName: "coupon" */ () => import('@/component/module_coupon'),
      ),
      Drawer: MyLazyComponent(
        /* webpackChunkName: "report" */ () => import('@/component/module_drawer'),
      ),
      Project: MyLazyComponent(
        /* webpackChunkName: "project" */ () => import('@/component/module_project'),
      ),
      Certification: MyLazyComponent(
        /* webpackChunkName: "certification" */ () => import('@/component/module_certification'),
      ),
      Review: MyLazyComponent(
        /* webpackChunkName: "review" */ () => import('@/component/module_review'),
      ),
      Card: MyLazyComponent(
        /* webpackChunkName: "recommend" */ () => import('@/component/module_card'),
      ),
      Service: MyLazyComponent(
        /* webpackChunkName: "service" */ () => import('@/component/module_service'),
      ),
      Seo: MyLazyComponent(/* webpackChunkName: "seo" */ () => import('@/component/module_seo')),
      Report: MyLazyComponent(
        /* webpackChunkName: "report" */ () => import('@/component/module_report'),
      ),
    });
  }

  return <Layout {...props} components={Components} />;
};

export default Structure;
